import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { useScrollHeader, useIntoViewAnimation, useIsMobile } from '../../../hooks';
import Footer from "../../../components/Footer/Footer";
import { Swiper, SwiperSlide } from 'swiper/react';
import './fcstIndex.less';
import 'swiper/css';
import 'swiper/css/pagination';
// import 'swiper/css/navigation';
import { getArticleList } from '../../../services/newsService';

import { Pagination, Navigation } from 'swiper/modules';

const stripHtml = (html) => {
  if (!html) return '';
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

export default function FCST({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发

  const navigate = useNavigate();
  // FCST研究院
  // const FcstList = [
  //   {
  //     title: '理论突破 - 弱视的皮层下受损',
  //     desc: '弱视患者的一个重要临床表现在于弱视眼对空间细节的敏感度降低，包括视锐度（眼睛辨别最小视角的能力）降低；对比度敏感度，尤其是对高空间频率（细密纹理）的对比度敏感度降低。...',
  //     date: '2024-10-31',
  //     img: '/images/home/news2.png',
  //     route: '/fcst/breakthroughTheory',
  //   },
  //   {
  //     title: '方法突破 - 结合增强现实的，可以针对弱视眼P通路进行矫正的双眼图像算法',
  //     desc: 'Xu等人在2010年证明了通过使用推拉（Push-pull）方法来减少眼优势（sensory eye dominance）的可能性。在训练过程中（图 C），受试者的任务是辨别非优势眼看到中的光栅朝向。 刺激首先向受试者的非优势眼呈现一个矩形框（注意提示），然后分别向双眼呈现一对正交光栅。...',
  //     date: '2024-10-31',
  //     img: '/images/home/news1.png',
  //     route: '/fcst/breakthroughMethod',
  //   },
  //   // {
  //   //   title: '什么是弱视？',
  //   //   desc: '弱视是一种视觉发育相关疾病，其特征为戴镜视力达不到同龄儿童正常视力下线或者两眼视力相差2行以上，且经眼科检查并未发现能够引起视力差的器质性病变。...',
  //   //   date: '2024-10-11',
  //   //   img: '/images/home/news3.png',
  //   //   route: '/fcst/identifyAmblyopia',
  //   // },
  //   // {
  //   //   title: '近视防控应该怎么做?',
  //   //   desc: <>
  //   //     首先判断是真性近视还是假性近视。<br />
  //   //     如果孩子出现"假性近视”，可以让孩子眼睛彻底放松，使眼睛慢慢恢复…
  //   //   </>,
  //   //   date: '2024-10-11',
  //   //   img: '/images/home/news4.png',
  //   //   route: '/fcst/identifyMyopia',
  //   // },
  // ]

  const [allArticleData, setAllArticleData] = useState([])
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [topArticleData, setTopArticleData] = useState([]);
  const typeList = ['文献速递', '科普专栏', '所有文章']
  const [currentType, setCurrentType] = useState(2);
  const tabRefs = useRef([]);
  const [leftBtnHovered, setLeftBtnHovered] = useState(false)
  const [rightBtnHovered, setRightBtnHovered] = useState(false)
  const [animateContent, setAnimateContent] = useState(false)
  const [animatePage, setAnimatePage] = useState(false)

  // 分页
  const [currentPage, setCurrentPage] = useState(1);
  const [loadedPages, setLoadedPages] = useState(1);
  const itemsPerPage = 9;
  // 计算总页数
  const totalPages = Math.ceil(total / itemsPerPage);
  // 检测是否是移动设备
  const isMobile = useIsMobile();

  // 展开更多
  const handleLoadMore = () => {
    if (loadedPages < totalPages && !loading) {
      const nextPage = loadedPages + 1;
      setLoadedPages(nextPage);
      fetchAllArticleData(nextPage, currentType, false, true);
    }
  };

  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(0);
  const [direction, setDirection] = useState('next'); // 用于管理动画进出方向
  const [isInitialRender, setIsInitialRender] = useState(true);
  const scrollableRefs = useRef([]);

  useEffect(() => {
    setTimeout(() => {
      if (scrollableRefs.current[currentIndex]) {
        scrollableRefs.current[currentIndex].scrollTop = 0;
      }
    }, 100);
  }, [currentIndex])

  const [fcstCoverHovered, setFcstCoverHovered] = useState(false)
  const [fcstBottomHovered, setFcstBottomHovered] = useState(false)

  // PC端--进入动画
  const refPc = useRef('')
  useIntoViewAnimation({
    ref: refPc,
    threshold: 0.1,
    className: 'Fcst--ani',
  })

  // 移动端--进入动画
  const refMobile = useRef('')
  useIntoViewAnimation({
    ref: refMobile,
    threshold: 0.1,
    className: 'Fcst--aniMobile',
  })

  // const handlePrev = () => {
  //   if (currentIndex > 0) {
  //     setCurrentIndex(currentIndex - 1);
  //   }
  // };
  // const handleNext = () => {
  //   if (currentIndex < FcstList.length - 1) {
  //     setCurrentIndex(currentIndex + 1);
  //   }
  // };


  // 获取置顶文章
  const fetchTopArticleData = async () => {
    try {
      const data = await getArticleList({
        bannerTop: 1,
        columnName: 'FCST研究院',
        status: 1,
      });
      const records = data?.records || [];
      setTopArticleData(records);
    } catch (error) {
      console.error(error);
    }
  };

  // 获取所有文章列表
  const fetchAllArticleData = async (page = 1, typeIndex = currentType, shouldAnimate = false, isLoadMore = false, delay = 500) => {
    if (loading) return;
    setLoading(true);
    try {
      const data = await getArticleList({
        pageNo: page,
        pageSize: itemsPerPage,
        columnName: 'FCST研究院',
        typeName: typeIndex !== 2 ? typeList[typeIndex] : '',
        // bannerTop: 0,
        status: 1,
      });
      const records = data?.records || [];
      if (shouldAnimate) {
        setAnimateContent(false);
        setAnimatePage(false);
      }
      setTimeout(() => {
        setTotal(data?.total || 0);
        if (isLoadMore) {
          setAllArticleData(prev => [...prev, ...records]);
        } else {
          setAllArticleData(records);
        }
        setLoading(false);
        if (shouldAnimate) {
          setAnimateContent(true);
          setAnimatePage(true);
        }
      }, delay);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTopArticleData();
    fetchAllArticleData(1);
    setTimeout(() => setAnimateContent(true), 4600);
    setTimeout(() => setAnimatePage(true), 5000);
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
    // 在组件挂载后，将isInitialRender设置为false
    const timer = setTimeout(() => {
      setIsInitialRender(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, []);

  return <div className="Fcst">
    <div className='Fcst_cover'>
      <div className="pageMargin">
        <div className="CompanyNews_cover-blockTop">
          <div className="ofy_hidden">
            {/* PC端 */}
            <div className="Fcst_cover-topPc flex_row flex_jc-sb">
              <div className="fz_32 fw_700 lh_38" style={{ width: '50%' }}>FCST研究院</div>
              <div className="flex_row flex_jc-sb gap_16" style={{ width: '50%' }}>
                <div className="fz_20 fw_500 lh_24">Focusight®<br />Research institute</div>
                <div className="fz_16 fw_500 lh_24" style={{ width: '400px' }}>集视医疗全球高技术研发团队，在理论和方法均有突破，及时了解我们的最新项目进度和产品研发事项。</div>
              </div>
            </div>
            {/* 移动端 */}
            <div className='Fcst_cover-topMobile flex_row flex_jc-sb'>
              <div>
                <div className="fz_18 fw_700 lh_21">FCST研究院</div>
                <div className="fz_14 fw_500 lh_16 mt_4">Focusight®<br />Research institute</div>
              </div>
              <div className="fz_12 fw_500 lh_16" style={{ width: '170px' }}>集视医疗全球高技术研发团队，在理论和方法均有突破，及时了解我们的最新项目进度和产品研发事项。</div>
            </div>
          </div>
        </div>
        <div className="Fcst_cover-blockBottom">
          <div className="of_hidden">
            {/* PC端 */}
            <div ref={refPc} className="Fcst_cover-contentPc flex_row flex_jc-sb flex_ai-c gap_16">
              <div
                className={`Fcst_content-sliderBtn flex_auto ${currentIndex === 0 ? 'disabled' : ''}`}
                onClick={() => {
                  if (currentIndex !== 0) {
                    setPrevIndex(currentIndex);
                    setCurrentIndex(currentIndex - 1)
                    setDirection('prev');
                  }
                }}
              >
                <img
                  className='Wearable_product-sliderBtnIcon'
                  src='./images/home/whiteLeftIcon.png'
                  alt=''
                />
              </div>
              <div className="flex_full flex_row of_hidden" >
                {topArticleData?.map((item, index) =>
                  <div
                    key={item.id}
                    className={`flex_row flex_jc-sb gap_16 ${index === currentIndex
                      ? direction === 'next'
                        ? 'slide-in-next'
                        : 'slide-in-prev'
                      : index === prevIndex
                        ? direction === 'next'
                          ? 'slide-out-next'
                          : 'slide-out-prev'
                        : ''
                      }`}
                    style={{ width: '100%', display: index === currentIndex ? '' : 'none' }}
                  >
                    <div className="Fcst_cover-contentImg flex_center">
                      <img
                        style={{ width: '100%' }}
                        src={item.coverUrl}
                        alt=''
                      />
                    </div>
                    <div className="Fcst_cover-contentRight">
                      <div className="Fcst_cover-contentRightBlock">
                        <div className="of_hidden FcstScollbar" style={{ height: '100%', overflowY: 'auto' }} ref={(el) => scrollableRefs.current[index] = el}>
                          <div className={`Fcst_contentRight-itemBlock ${isInitialRender && currentIndex === 0 ? 'initial-animation' : ''}`}>
                            <div className="fz_18 fw_500 lh_21">{item.createTime.slice(0, 10)}</div>
                            <div>
                              <div className="fz_32 fw_700 lh_38">{item.title}</div>
                              <div className="fz_16 fw_500 lh_24 multiline-ellipsis" style={{ marginTop: '5%' }}>{stripHtml(item.content)}</div>
                            </div>
                            <div
                              className='Fcst_cover-btn flex_row flex_jc-c flex_ai-c'
                              onClick={() => navigate(`/newsInfo/detail/${item?.id}`)}
                              onMouseEnter={() => setFcstCoverHovered(true)}
                              onMouseLeave={() => setFcstCoverHovered(false)}
                            >
                              <div>阅读文章</div>
                              <img
                                className='Wearable_product-rightArrow'
                                src={fcstCoverHovered ? './images/home/arrow-right-blackLine.png' : './images/home/arrow-right-whiteLine.png'}
                                alt=''
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>)}
              </div>
              <div
                className={`Fcst_content-sliderBtn flex_auto ${currentIndex === topArticleData?.length - 1 ? 'disabled' : ''}`}
                onClick={() => {
                  if (currentIndex !== topArticleData?.length - 1) {
                    setPrevIndex(currentIndex);
                    setCurrentIndex(currentIndex + 1)
                    setDirection('next');
                  }
                }}
              >
                <img
                  className='Wearable_product-sliderBtnIcon'
                  src='./images/home/whiteRightIcon.png'
                  alt=''
                />
              </div>
            </div>
            {/* Swiper组件实现 */}
            {/* <div ref={refPc} className="Fcst_cover-contentPc flex_row flex_ai-c gap_20">
              <div
                className={`Fcst_cover-swiperButtonPrev flex_center ${currentIndex === 0 ? 'disabled' : ''}`}
                onClick={handlePrev}
              >
                <img
                  className='Wearable_product-sliderBtnIcon'
                  src='./images/home/whiteLeftIcon.png'
                  alt=''
                />
              </div>
              <Swiper
                style={{ width: 'calc(100% - 180px)' }}
                navigation={{
                  nextEl: '.Fcst_cover-swiperButtonNext',
                  prevEl: '.Fcst_cover-swiperButtonPrev',
                }}
                modules={[Navigation]}
              >
                {FcstList.map((item, index) => <SwiperSlide key={index} className='flex_row flex_jc-c'>
                  <div className='flex_row flex_jc-sb gap_16'>
                    <div className="Fcst_cover-contentImg flex_center">
                      <img
                        style={{ width: '100%' }}
                        src={item.img}
                        alt=''
                      />
                    </div>
                    <div className="Fcst_cover-contentRight">
                      <div className="Fcst_cover-contentRightBlock">
                        <div className="of_hidden" style={{ height: '100%' }}>
                          <div className={`Fcst_contentRight-itemBlock ${isInitialRender && currentIndex === 0 ? 'initial-animation' : ''}`}>
                            <div className="fz_18 fw_500 lh_21">{item.date}</div>
                            <div>
                              <div className="fz_32 fw_700 lh_38 ellipsis">{item.title}</div>
                              <div className="fz_16 fw_500 lh_24 multiline-ellipsis" style={{ marginTop: '5%' }}>{item.desc}</div>
                            </div>
                            <div
                              className='Fcst_cover-btn flex_row flex_jc-c flex_ai-c'
                              onClick={() => navigate(item.route)}
                              onMouseEnter={() => setFcstCoverHovered(true)}
                              onMouseLeave={() => setFcstCoverHovered(false)}
                            >
                              <div>阅读文章</div>
                              <img
                                className='Wearable_product-rightArrow'
                                src={fcstCoverHovered ? './images/home/arrow-right-blackLine.png' : './images/home/arrow-right-whiteLine.png'}
                                alt=''
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>)}
              </Swiper>
              <div
                className={`Fcst_cover-swiperButtonNext flex_center ${currentIndex >= FcstList.length - 1 ? 'disabled' : ''}`}
                onClick={handleNext}
              >
                <img
                  className='Wearable_product-sliderBtnIcon'
                  src='./images/home/whiteRightIcon.png'
                  alt=''
                />
              </div>
            </div> */}
            {/* 移动端 */}
            <div ref={refMobile} className="Fcst_cover-contentMobile">
              <Swiper
                className='Fcst_cover-swiper'
                pagination={true}
                modules={[Pagination]}
              >
                {topArticleData?.map((item, index) => <SwiperSlide key={index}>
                  <div
                    className='flex_col gap_12'
                    style={{ width: '100%' }}
                  >
                    <div className="Fcst_cover-contentImg flex_center">
                      <img
                        style={{ width: '100%' }}
                        src={item.coverUrl}
                        alt=''
                      />
                    </div>
                    <div className="Fcst_cover-contentRight">
                      <div className="Fcst_cover-contentRightBlock">
                        <div className="of_hidden" style={{ height: '100%' }}>
                          <div className={`Fcst_contentRight-itemBlock ${isInitialRender && currentIndex === 0 ? 'initial-animation' : ''}`}>
                            <div className="fz_12 fw_500 lh_14">{(item.createTime).substring(0, 10)}</div>
                            <div>
                              <div className="fz_18 fw_700 lh_21">{item.title}</div>
                              <div className="fz_12 fw_500 lh_16 mt_10 multiline-ellipsis-5">{stripHtml(item?.content)}</div>
                            </div>
                            <div
                              className='Fcst_cover-btn flex_row flex_jc-c flex_ai-c'
                              onClick={(() => navigate(`/newsInfo/detail/${item.id}`))}
                              onMouseEnter={() => setFcstCoverHovered(true)}
                              onMouseLeave={() => setFcstCoverHovered(false)}
                            >
                              <div>阅读文章</div>
                              <img
                                className='Wearable_product-rightArrowMobile'
                                src={fcstCoverHovered ? './images/home/arrow-right-blackLine.png' : './images/home/arrow-right-whiteLine.png'}
                                alt=''
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>)}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="Fcst_bottomContent bgc_F5F9FD">
      <div className="pageMargin">
        <div className="CompanyNews_content-top">
          <div className="of_hidden">
            <div className="CompanyNews_content-topBlock c_85899E flex_row flex_jc-c">
              {typeList.map((i, index) => <div
                key={index}
                ref={el => tabRefs.current[index] = el}
                className={`Fcst_bottomContent-typeItem cur_p ${index === currentType ? 'active' : ''}`}
                onClick={(() => {
                  if (index !== currentType) {
                    setCurrentType(index)
                    setCurrentPage(1);
                    setLoadedPages(1);
                    fetchAllArticleData(1, index, true);
                  }
                })}
              >
                {i}</div>)}
            </div>
          </div>
        </div>
        <div className={`Fcst_bottomContent-block ${animateContent ? 'animate' : ''}`}>
          {allArticleData?.map((item) => <div
            key={item.id}
            className="CompanyNews_content-item"
            onClick={() => {
              if (isMobile) {
                navigate(`/newsInfo/detail/${item?.id}`)
              }
            }}
          >
            <div className="CompanyNews_content-itemImg flex_center">
              <img
                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 10 }}
                src={item.coverUrl}
                alt=''
              />
              <div className="Fcst_bottomContent-btnBlock flex_center">
                <div
                  className="Fcst_bottomContent-btn cur_p"
                  onClick={() => navigate(`/newsInfo/detail/${item?.id}`)}
                  onMouseEnter={() => setFcstBottomHovered(true)}
                  onMouseLeave={() => setFcstBottomHovered(false)}
                >
                  <div className="fz_18 fw_500 lh_21">阅读文章</div>
                  <img
                    className='Wearable_product-rightArrow'
                    src={fcstBottomHovered ? './images/home/arrow-right-blackLine.png' : './images/home/arrow-right-whiteLine.png'}
                    alt=''
                  />
                </div>
              </div>
            </div>
            <div className="CompanyNews_content-itemDate c_85899E">{item.createTime.split(' ')[0]}</div>
            <div className="CompanyNews_content-itemTitle of_ellipsis">{item.title}</div>
            <div className="CompanyNews_content-itemDesc c_85899E ellipsis_2">{stripHtml(item?.content)}</div>
          </div>)}
        </div>
        {/* PC端分页 */}
        <div className="CompanyNews_pageBlockPc">
          {totalPages > 1 && <div className={`Fcst_bottomContent-page flex_row flex_jc-c flex_ai-c ${animatePage ? 'animate' : ''}`}>
            <div
              className="CompanyNews_content-leftBtn flex_center"
              style={{ cursor: currentPage === 1 || loading ? 'no-drop' : 'pointer' }}
              onMouseEnter={() => setLeftBtnHovered(true)}
              onMouseLeave={() => setLeftBtnHovered(false)}
              onClick={(() => {
                if (currentPage !== 1 && !loading) {
                  const nextPage = currentPage - 1;
                  setCurrentPage(nextPage);
                  fetchAllArticleData(nextPage);
                }
              })}
            >
              <img
                className='Wearable_product-sliderBtnIcon'
                src={leftBtnHovered ? './images/home/whiteLeftIcon.png' : './images/home/blackLeftIcon.png'}
                alt=''
              />
            </div>
            <div className="flex_row gap_54 ml_86 mr_86">
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                <div
                  key={page}
                  className={`fz_24 fw_500 lh_28 cur_p ${currentPage === page ? 'c_00' : 'c_85899E'}`}
                  onClick={() => {
                    if (!loading) {
                      setCurrentPage(page);
                      fetchAllArticleData(page);
                    }
                  }}
                >
                  {page}</div>
              ))}
            </div>
            <div
              className="CompanyNews_content-leftBtn flex_center"
              style={{ cursor: currentPage === totalPages || loading ? 'no-drop' : 'pointer' }}
              onMouseEnter={() => setRightBtnHovered(true)}
              onMouseLeave={() => setRightBtnHovered(false)}
              onClick={(() => {
                if (currentPage !== totalPages && !loading) {
                  const nextPage = currentPage + 1;
                  setCurrentPage(nextPage);
                  fetchAllArticleData(nextPage);
                }
              })}
            >
              <img
                className='Wearable_product-sliderBtnIcon'
                src={rightBtnHovered ? './images/home/whiteRightIcon.png' : './images/home/blackRightIcon.png'}
                alt=''
              />
            </div>
          </div>}
        </div>
        {/* 移动端——展开更多 */}
        {isMobile && loadedPages < totalPages && <div className='CompanyNews_pageBlockMobile flex_row flex_jc-c'>
          <div
            className='CompanyNews_mobileBtn flex_row flex_jc-c flex_ai-c'
            onClick={handleLoadMore}
          >
            <div>展开更多</div>
            <img
              className='Wearable_product-rightArrowMobile'
              src='./images/home/arrow-down-blackLine.png'
              alt=''
            />
          </div>
        </div>}
      </div>
    </div>
    <Footer />
  </div>
}
